export const PAYMENT_HISTORIES_RESET_STATE = 'PAYMENT_HISTORIES_RESET_STATE';
export const PAYMENT_HISTORIES_CURRENT_ITEM = 'PAYMENT_HISTORIES_CURRENT_ITEM';

export const PAYMENT_HISTORIES_REQUEST_LOADING = 'PAYMENT_HISTORIES_REQUEST_LOADING';
export const PAYMENT_HISTORIES_REQUEST_SUCCESS = 'PAYMENT_HISTORIES_REQUEST_SUCCESS';
export const PAYMENT_HISTORIES_REQUEST_FAILED = 'PAYMENT_HISTORIES_REQUEST_FAILED';

export const PAYMENT_HISTORIES_CURRENT_ACTION = 'PAYMENT_HISTORIES_CURRENT_ACTION';
export const PAYMENT_HISTORIES_RESET_ACTION = 'PAYMENT_HISTORIES_RESET_ACTION';